/**
 * Проект лендинга
 */
export interface IProject {
    _id: string;
    title: string;
    url: string;
    cities: string;
    seo: {
        title: string;
        description: string;
        robots?: string;
    };
    available: {
        isAuth: boolean;
        isGuest: boolean;
    };
    owner: unknown;
    isActive: boolean;
    blocksCount: number;
    createdAt: number;
    updatedAt: number;
    deletedAt?: number;
    publicVersionId?: string;
    publishedAt?: number;
    image?: string;
}

export enum EElementType {
    Project = 'project',
    Block = 'block',
    Text = 'text',
    TextWithoutContent = 'textWithoutContent',
    Button = 'button',
    Image = 'image',
    Column = 'column',
    AccordionColumn = 'accordionColumn',
    LigalColumn = 'ligalColumn',
    HeaderColumn = 'headerColumn',
    ImageSection = 'imageSection',
    PhoneForm = 'phoneForm',
    InstallmentPlanForm = 'installmentPlanForm',
    InstallmentTariffForm = 'installmentTariffForm',
    RTE = 'rte',
    SliderImage = 'sliderImage',
    Carousel = 'carousel',
    CarouselImage = 'carouselImage',
    ImageGridColumn = 'imageGridColumn',
    AccordionTab = 'accordionTab',
    TabColumn = 'tabColumn',
    BlockGridColumn = 'blockGridColumn',
    AgeRestriction = 'ageRestriction',
    ColumnButton = 'columnButton',
}

/**
 * Конкретный лендинг
 */
export interface ICurrentProject extends IProject {
    additionalData?: any;
    body: INormalizedLandingElement;
    type: EElementType;
}

export interface IImage {
    _id: string;
    createdAt: number;
    destination: string;
    encoding: string;
    fieldname: string;
    filename: string;
    mimetype: string;
    originalname: string;
    owner: string;
    path: string;
    webp: string;
    projectId: string;
    size: number;
}

export interface IElement {
    title: string;
    type: EElementType;
    isActive?: boolean;
    properties?: Record<string, any>;
    label?: string;
}

/**
 * Элемент лединга
 */
export interface ILandingElement extends IElement {
    children?: ILandingElement[];
}

export interface INormalizedLandingElement {
    [key: string]: IFlattenLandingElement;
}

export interface IFlattenLandingElement extends IElement {
    id: string;
    renderId: string;
    parentId?: string;
    level: number;
    hasChildren: boolean;
    blockId: string;
    isOpen?: boolean;
    isVisible?: boolean;
    customStyles?: any;
    scrollId?: string;
}
